<template>
    <Label class="mb-1">{{ $t("event_types.location.add") }}</Label>
    <Select v-model="model">
        <SelectTrigger>
            <SelectValue placeholder="" />
        </SelectTrigger>
        <SelectContent>
            <SelectGroup>
                <SelectItem
                    v-for="locationOption in options"
                    :key="locationOption.id"
                    :value="locationOption.id"
                >
                    <div class="gap-3 flex">
                        <div class="h-5 w-5" v-html="locationOption.icon"></div>
                        {{ locationOption.name }}
                    </div>
                </SelectItem>
            </SelectGroup>
        </SelectContent>
    </Select>
</template>

<script setup lang="ts">
import { Label } from "@/components/ui/label";

import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";

const model = defineModel<string>();

interface LocationOption {
    id: string;
    icon: string;
    name: string;
}

const props = defineProps<{
    options: LocationOption[];
}>();
</script>
